import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, moduleSequences } from 'app/pwa/app.cerebral';

import ParticipantDidSomething from '../common/ParticipantDidSomething';
import UserDidSomething from '../common/UserDidSomething';

import { useText } from 'common/hooks';
import { ICON, TAG_CATEGORY } from 'resources/constants';
import { ButtonWrapper } from './elements';
import { PlmgButton } from '@ducky/plumage-react';

type Props = {
  readonly datetime: number;
  readonly score: number;
  readonly profileKey: string;
  readonly category: TAG_CATEGORY;
};

const deps = {
  maxScore: state.challenge.maxScore,
  indicator: state.challenge.campaign.indicator,
  userProfileKey: state.appContainer.user.uid,
  events: state.challenge.events.events,
  showTagModal: moduleSequences.challenge.tagModal.showTagModalClicked,
  userQuizScoreAll: state.challenge.tagModal.computedUserQuizScoreAll,
};

function QuizCompleted({
  datetime,
  score,
  profileKey,
  category,
  userProfileKey,
  showTagModal,
  userQuizScoreAll,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  if (userProfileKey === profileKey) {
    return (
      <UserDidSomething
        profileKey={profileKey}
        icon={ICON.school}
        datetime={datetime}
        mainText={t(`challenge.user_quiz_completed.${category}`, {
          score,
        })}
        smallText={t('challenge.user_quiz_completed_nice_work')}
      />
    );
  }

  const userHasTakenQuiz = userQuizScoreAll[category].isCompleted;

  return (
    <ParticipantDidSomething
      profileKey={profileKey}
      icon={ICON.school}
      datetime={datetime}
    >
      <>
        <span>{t(`challenge.participant_quiz_completed.${category}`)}</span>
        {!userHasTakenQuiz && (
          <ButtonWrapper>
            <PlmgButton
              design="outline"
              size="small"
              fullWidth
              onClick={() =>
                showTagModal({
                  tag: category,
                  openQuiz: true,
                })
              }
              text={t(
                `challenge.participant_quiz_completed_prompt.${category}`
              )}
            />
          </ButtonWrapper>
        )}
      </>
    </ParticipantDidSomething>
  );
}

export default connect<Props, typeof deps>(deps, QuizCompleted);
